import React from 'react';
import { useIntl } from 'react-intl';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

/**
 * Loading skeleton for the Tariff List page.
 * Mirrors the layout of `TariffList/index.jsx`: breadcrumbs, heading,
 * intro text, then a series of meter groups with tariff row skeletons.
 * @returns {React.ReactElement} Placeholder component.
 */
function Placeholder() {
  const intl = useIntl();

  const breadcrumbProperties = intl.formatMessage({
    id: 'tariff.tariff_list.placeholder.breadcrumbs.properties',
    defaultMessage: 'Properties',
  });
  const breadcrumbTariffs = intl.formatMessage({
    id: 'tariff.tariff_list.placeholder.breadcrumbs.tariffs',
    defaultMessage: 'Tariffs',
  });
  const headingTariffs = intl.formatMessage({
    id: 'tariff.tariff_list.placeholder.heading.tariffs',
    defaultMessage: 'Tariffs',
  });

  return (
    <div aria-hidden="true" inert>
      <Breadcrumbs
        breadcrumbs={[
          { name: breadcrumbProperties, path: '/properties' },
          { name: <span className="placeholder placeholder-glow bg-darken" style={{ width: '10rem' }} /> },
          { name: breadcrumbTariffs },
        ]}
      />
      <Heading
        title={<span className="placeholder placeholder-glow bg-darken" style={{ width: '12rem' }} />}
        subtitle={<span className="placeholder placeholder-glow bg-darken" style={{ width: '18rem' }} />}
        context={headingTariffs}
      />
      <p>
        <span className="placeholder placeholder-glow bg-darken col-8" />
      </p>
      <div className="property-all-tariffs-list">
        {[0, 1].map((meterIdx) => (
          <React.Fragment key={`placeholder-meter-${meterIdx}`}>
            <hr />
            <div>
              <h3>
                <span className="placeholder placeholder-glow bg-darken col-4" />
                <br />
                <small>
                  <span className="placeholder placeholder-glow bg-darken col-3" />
                </small>
              </h3>
              {[0, 1, 2].map((tariffIdx) => (
                <div className="mb-3" key={`placeholder-tariff-${meterIdx}-${tariffIdx}`}>
                  <span className="placeholder placeholder-glow bg-darken col-6" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-10" />
                </div>
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default Placeholder;
